import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../image/favicon.jpeg'
function AppLogo() {
  return (
   <Link
  to={'/'}
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
    color: 'inherit',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  }}
>
  <img src={logo} alt="logo" width="50px" style={{ height: 'auto' }} />
  <span>Loyalty Jar</span>
</Link>
  )
}

export default AppLogo
